import ticketLink from "../staticQueries/ticketLink"
import { TNavigationJson } from "../types"

const TicketLink = (): string | undefined => {
    try {
      const ticketLinkJson: TNavigationJson = JSON.parse(ticketLink().json);
      if (ticketLinkJson.label === "Ticket") {
        return ticketLinkJson.link;
      }
    } catch (error) {
      console.log("Failed to parse ticket link JSON:", error);
      return undefined;
    }
  
    // Return undefined or a default value if the ticket link is not found or an error occurs
    return undefined;
  };
  
  export default TicketLink;
